'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _convertMucd = require('./convertMucd');

var separator = {
  1: '.',
  3: ' ',
  11: '.',
  15: ' ',
  18: '.'
};

var currencySign = {
  1: ':-',
  3: ',—',
  11: ',-',
  15: ',-',
  18: ':-'
};

var formatPrice = function formatPrice(price, mucd) {
  var roundUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var siteId = (0, _convertMucd.convertMucd)(mucd);
  var trimmed = roundUp ? Math.ceil(price || 0) : Math.floor(price || 0);
  var priceString = trimmed.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + separator[siteId]);
  return '' + priceString + currencySign[siteId];
};

exports.default = formatPrice;